<div class="min-h-screen flex justify-center items-center p-6">
  <div class="w-full max-w-3xl bg-card border-foreground-tertiary border shadow-xl rounded-2xl p-8">
    <!-- Header -->
    <div class="flex items-center gap-3 mb-6">
      <i class="pi pi-credit-card text-3xl text-primary"></i>
      <h2 class="text-2xl text-primary font-semibold">Payment Summary</h2>
    </div>

    <!-- Appointment Details -->
    <div class="bg-card-contrast rounded-xl p-6 border border-gray-200 mb-6">
      <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div>
          <p class="text-gray-500 text-sm">Doctor</p>
          <p class="font-medium text-lg">
            {{ summaryData?.DoctorName }}
          </p>
        </div>

        <div>
          <p class="text-gray-500 text-sm">Patient</p>
          <p class="font-medium text-lg">
            {{ summaryData?.userName }}
          </p>
        </div>

        <div>
          <p class="text-gray-500 text-sm">Appointment Date</p>
          <p class="font-medium text-lg">
            {{ summaryData?.selectedDate | date: 'fullDate' }}
          </p>
        </div>

        <div>
          <p class="text-gray-500 text-sm">Time Slot</p>
          <p class="font-medium text-lg">
            {{ summaryData?.selectedSlot }}
          </p>
        </div>
      </div>
    </div>

    <!-- Payment Amount -->
    <div
      class="flex justify-between items-center bg-primary-50 border border-primary rounded-xl p-5 mb-6"
    >
      <span class="text-lg font-medium text-gray-700">Total Amount</span>
      <span class="text-2xl font-bold text-primary"> ₹ {{ summaryData?.doctorFee }} </span>
    </div>

    <!-- Payment Mode -->
    <div class="mb-6">
      <h3 class="font-semibold mb-4 text-lg">Select Payment Mode</h3>

      <div class="flex gap-6">
        <div
          class="flex items-center gap-3 border rounded-xl p-4 w-full hover:shadow-md transition cursor-pointer"
          [ngClass]="{ 'border-primary bg-primary-50': paymentMode === 'online' }"
          (click)="paymentMode = 'online'"
        >
          <p-radioButton name="payment" value="online" [(ngModel)]="paymentMode"> </p-radioButton>

          <i class="pi pi-wallet text-primary text-xl"></i>
          <span class="font-medium">Online Payment</span>
        </div>

        <div  *ngIf="summaryData?.selectedType === ConsultationType.Offline"
          class="flex items-center gap-3 border rounded-xl p-4 w-full hover:shadow-md transition cursor-pointer"
          [ngClass]="{ 'border-primary bg-primary-50': paymentMode === 'cash' }"
          (click)="paymentMode = 'cash'"
        >
          <p-radioButton name="payment" value="cash" [(ngModel)]="paymentMode"> </p-radioButton>

          <i class="pi pi-money-bill text-green-600 text-xl"></i>
          <span class="font-medium">Cash on Visit</span>
        </div>
      </div>
    </div>

    <!-- Confirm Button -->
    <div class="flex justify-end">
      <p-button
        label="Confirm & Proceed"
        icon="pi pi-check"
        [disabled]="!paymentMode"
        (click)="payClick()"
        styleClass="p-button-primary px-6 py-3 rounded-xl shadow-md"
      >
      </p-button>
    </div>
  </div>
</div>
